module.exports = __webpack_public_path__ + "static/spotify_logo-6707c0ed7da2d4ac194ee16a5feb185d.png";